import { convertirFechaFirebase } from "./utiles_objetos";

export class Historial{
    constructor({
        fechacambio = new Date,
        cambioant = "",
        cambionew = "",
        motivocambio = "",
        codigo = "",
        cambiadoPor = "",
        tipo = "",
    } ={}){
        this.fechacambio = fechacambio;
        this.cambioant = cambioant;
        this.cambionew = cambionew;
        this.motivocambio = motivocambio;
        this.codigo = codigo;
        this.cambiadoPor = cambiadoPor;
        this.tipo = tipo;
    }

    static fromJson(json){

        const fechacambioLocal = convertirFechaFirebase(json['fechacambio']);


        return new Historial({
            fechacambio: fechacambioLocal,
            cambioant: json['cambioant'] || "",
            cambionew: json['cambionew'] || "",
            motivocambio: json['motivocambio'] || "",
            codigo: json['codigo'] || "",
            cambiadoPor: json['cambiadoPor'] || "",
            tipo: json['tipo'] || "DEFAULT",
        });

    }

}